import React, { useState } from "react";

import { buildColumns } from "./lib/constants";
import ReactTable from "react-table";
import { NewMessageForm } from "./new-message-form";

export const NotificationsIndex = () => {
    const [rows, setRows] = useState([
        {
            endDate: "2021-10-27T12:42:34.2378545+00:00",
            isActive: true,
            message: "Attention: We will be deploying code at 4pm CT. Please ensure your work is saved and you exit the application by then. Thank you!",
            messageGroup: null,
            messageType: "String",
            startDate: "2021-10-27T12:12:34.2378545+00:00",
        },
    ]);

    const handleEditMessage = () => {
        //console.log("EDIT");
    };

    const handleDeleteMessage = () => {
        //console.log("DELETE");
    };

    const handleSubmitNewMessage = (formState) => {
        setRows((state) => [...state, { ...formState }]);
    };

    return (
        <div>
            <h1>Notifications</h1>
            <ReactTable data={rows} columns={buildColumns(handleEditMessage, handleDeleteMessage)} filterable={false} sortable={false} minRows="5" />
            <br />
            <h2>Add New Notification</h2>
            <div>
                <NewMessageForm onSubmit={handleSubmitNewMessage} />
            </div>
        </div>
    );
};

export default NotificationsIndex;
